/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElTableV2 as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/table-v2/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "marginB20"
}, "请前往渠道后台获取ID后配置此处对应商品中。此处只能关联商品ID，如需新增或修改商品信息，请前往“游戏通用商品管理”", -1);
const _hoisted_2 = {
  class: "flex justify-between marginB10"
};
import { apiUsdkGetCurrencyList, apiUsdkGetGoodsConfEdit, apiUsdkGetPayType } from '@/api/usdk';
import UseGoodsHook, { UsePropConfig } from './goodsHooks';
import ultra_export_json_to_excel from '@ultra/share/utils/exportToExcel.js';
import { formatJson, getMerger } from '@/utils/util';
import InputComponent from './modules/input';
import SelectComponent from './modules/select';
export default /*#__PURE__*/_defineComponent({
  __name: 'globalGoods',
  props: UsePropConfig(),
  setup(__props) {
    const contentWidth = computed(() => {
      return document.getElementsByClassName('u-card')[0].getElementsByClassName('content')[0].clientWidth - 40 || 1200;
    });
    const props = __props;
    const filterVal = ref(['goodsId', 'goodsName', 'price', 'currency', 'goodsDesc']);
    const payTypes = ref([]);
    const openPays = ref([]);
    const {
      // propsConfig,
      confirmLoading,
      tableData,
      loadingTable,
      isEdit,
      oldTableData,
      handleEditGoods,
      handlePatchInputClick,
      handleFileChange,
      inputRef
    } = UseGoodsHook(filterVal.value, props, 2, 'global');
    const columns = ref([{
      key: 'goodsId',
      dataKey: 'goodsId',
      title: '游戏商品ID',
      width: 100
    }, {
      key: 'goodsName',
      dataKey: 'goodsName',
      title: '游戏商品名称',
      width: 150,
      cellRenderer: ({
        rowData,
        column
      }) => {
        const onChange = value => {
          rowData[column.dataKey] = value;
        };
        return h(InputComponent, {
          modelValue: rowData[column.dataKey],
          disabled: !isEdit.value,
          placeholder: '输入商品名称',
          onChange
        });
      }
    }, {
      key: 'price',
      dataKey: 'price',
      title: '商品金额(元)',
      width: 150,
      cellRenderer: ({
        rowData,
        column
      }) => {
        const onChange = value => {
          rowData[column.dataKey] = value;
        };
        return h(InputComponent, {
          modelValue: rowData[column.dataKey],
          disabled: !isEdit.value,
          placeholder: '输入商品价格',
          type: 'number',
          onChange
        });
      }
    }, {
      key: 'currency',
      dataKey: 'currency',
      title: '商品币种',
      width: 150,
      cellRenderer: ({
        rowData,
        column
      }) => {
        const onChange = value => {
          rowData[column.dataKey] = value;
        };
        return h(SelectComponent, {
          modelValue: rowData[column.dataKey],
          disabled: !isEdit.value,
          placeholder: '请选择币种',
          options: currencyList.value,
          optionLabel: 'desc',
          optionValue: 'currency',
          onChange
        });
      }
    }, {
      key: 'goodsDesc',
      dataKey: 'goodsDesc',
      title: '商品描述',
      width: 200
    }]);
    const currencyList = ref([]);
    // 获取支付方式
    const getPayType = () => {
      apiUsdkGetPayType().then(res => {
        if (res.code === 0) {
          payTypes.value = res.data;
          console.log('payTypes', payTypes.value);
        }
      });
    };
    // 获取币种
    const getCurrencyList = () => {
      apiUsdkGetCurrencyList().then(res => {
        if (res.code === 0) {
          currencyList.value = res.data;
        }
      });
    };
    const generateColumn = () => {
      console.log({
        openPays
      });
      payTypes.value.forEach(item => {
        if (openPays.value.includes(item.key)) {
          let obj = {};
          let width = 250;
          if (item.key > 2 && item.key < 11) {
            width = 400;
            obj = {
              key: `payType${item.key}`,
              dataKey: `payType${item.key}`,
              title: item.value,
              width: width,
              cellRenderer: ({
                rowData,
                column
              }) => {
                const onChangePrice = value => {
                  rowData[column.dataKey].price = value;
                };
                const onChangeCurrency = value => {
                  rowData[column.dataKey].currency = value;
                };
                const onChangeGoodsId = value => {
                  rowData[column.dataKey].goodsId = value;
                };
                return h('div', {
                  className: 'flex'
                }, [h(InputComponent, {
                  modelValue: rowData[column.dataKey].price,
                  disabled: !isEdit.value,
                  placeholder: '输入商品价格',
                  type: 'number',
                  onChange: onChangePrice
                }), h(SelectComponent, {
                  modelValue: rowData[column.dataKey].currency,
                  disabled: !isEdit.value,
                  placeholder: '请选择币种',
                  options: currencyList.value,
                  optionLabel: 'desc',
                  optionValue: 'currency',
                  onChange: onChangeCurrency
                }), h(InputComponent, {
                  modelValue: rowData[column.dataKey].goodsId,
                  disabled: !isEdit.value,
                  placeholder: '输入商品ID',
                  onChange: onChangeGoodsId
                })]);
              }
            };
          } else {
            obj = {
              key: `payType${item.key}`,
              dataKey: `payType${item.key}`,
              title: item.value,
              width: width,
              cellRenderer: ({
                rowData,
                column
              }) => {
                const onChange = value => {
                  rowData[column.dataKey].goodsId = value;
                };
                return h(InputComponent, {
                  modelValue: rowData[column.dataKey].goodsId,
                  disabled: !isEdit.value,
                  placeholder: '输入商品ID',
                  onChange
                });
              }
            };
          }
          columns.value.push(obj);
        }
      });
    };
    // 获取商品配置
    const getGoodsConf = () => {
      loadingTable.value = true;
      apiUsdkGetGoodsConfEdit({
        gid: props.gid,
        cid: props.channel.cid
      }).then(res => {
        if (res.code === 0) {
          let data = res.data;
          let first = data[0];
          payTypes.value.forEach(item => {
            if (first[`payType${item.key}`]) {
              openPays.value.push(item.key);
              if (item.key > 2 && item.key < 11) {
                filterVal.value.push(`payType${item.key}.price`, `payType${item.key}.currency`, `payType${item.key}.goodsId`);
              } else {
                filterVal.value.push(`payType${item.key}.goodsId`);
              }
            }
          });
          oldTableData.value = JSON.parse(JSON.stringify(res.data));
          tableData.value = data;
          generateColumn();
        }
      }).finally(() => {
        loadingTable.value = false;
      });
    };
    const exportGoods = () => {
      const headers = [['', '', '', '', ''], ['游戏商品ID', '商品名称', '商品金额(元)', '币种', '商品描述']];
      const _filterVal = filterVal.value;
      const merges = [];
      payTypes.value.forEach(item => {
        if (openPays.value.includes(item.key)) {
          let i = headers[0].length;
          if (item.key > 2 && item.key < 11) {
            headers[0].push(item.value, '', '');
            headers[1].push('商品价格', '币种', '商品ID');
            merges.push(`${getMerger(i)}1:${getMerger(i + 2)}1`);
          } else {
            headers[0].push(item.value);
            headers[1].push('商品ID');
          }
        }
      });
      const data = formatJson(_filterVal, tableData.value);
      ultra_export_json_to_excel({
        sheets: [{
          headers,
          merges,
          data,
          name: '商品ID'
        }, {
          header: ['币种', '英文'],
          data: [['美元', 'USD'], ['港元', 'HKD'], ['欧元', 'EUR'], ['新台币', 'TWD'], ['马来西亚林吉特', 'MYR'], ['菲律宾比索', 'PHP'], ['印尼卢比', 'IDR'], ['泰铢', 'THB'], ['韩元', 'KRW'], ['越南盾', 'VND'], ['印度卢比', 'INR'], ['新加坡元', 'SGD'], ['日元', 'JPY'], ['人名币', 'CNY'], ['托曼', 'IRR']],
          name: '币种对照'
        }],
        filename: `${props.channel.name}_全球商品配置_${new Date().toLocaleString()}`
      });
    };
    onMounted(async () => {
      getCurrencyList();
      await getPayType();
      await getGoodsConf();
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_table_v2 = __unplugin_components_1;
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        disabled: _unref(tableData).length == 0,
        onClick: exportGoods
      }, {
        default: _withCtx(() => [_createTextVNode("导出商品")]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_el_button, {
        class: "marginL10",
        type: "primary",
        onClick: _unref(handlePatchInputClick)
      }, {
        default: _withCtx(() => [_createTextVNode("导入商品")]),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        loading: _unref(confirmLoading),
        onClick: _cache[0] || (_cache[0] = $event => _unref(handleEditGoods)(_unref(payTypes), _unref(openPays))),
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(isEdit) ? '保存商品' : '编辑商品'), 1)]),
        _: 1
      }, 8, ["loading"])])])]), _withDirectives(_createVNode(_component_el_table_v2, {
        columns: _unref(columns),
        data: _unref(tableData),
        width: _unref(contentWidth),
        height: 500,
        fixed: ""
      }, null, 8, ["columns", "data", "width"]), [[_directive_loading, _unref(loadingTable)]]), _createElementVNode("input", {
        type: "file",
        accept: ".xls,.xlsx",
        ref_key: "inputRef",
        ref: inputRef,
        multiple: false,
        onChange: _cache[1] || (_cache[1] =
        //@ts-ignore
        (...args) => _unref(handleFileChange) && _unref(handleFileChange)(...args)),
        style: {
          "display": "none"
        }
      }, null, 544)], 64);
    };
  }
});